import { Config } from "@/shared/config";

export default {
  employee: {
    clientId: Config.Okta.ClientId,
    issuer: Config.Okta.Issuer,
    redirectUri: window.location.origin + "/auth/login",
    scopes: ["openid", "profile", "email"],
    pkce: true
  },
  employer: {
    clientId: Config.EmployerOkta.ClientId,
    issuer: Config.EmployerOkta.Issuer,
    redirectUri: window.location.origin + "/login",
    scopes: ["openid", "profile", "email"],
    pkce: true
  },
  admin: {
    clientId: Config.AdminOkta.ClientId,
    issuer: Config.AdminOkta.Issuer,
    redirectUri: window.location.origin + "/admin/login",
    scopes: ["openid", "profile", "email"],
    pkce: true
  },
  features: {
    employee: {
      autoPush: true,
      multiOptionalFactorEnroll: true,
      idpDiscovery: true,
      showPasswordToggleOnSignInPage: true,
      rememberMe: true
    },
    employer: {
      autoPush: true,
      multiOptionalFactorEnroll: true,
      idpDiscovery: false,
      showPasswordToggleOnSignInPage: true,
      rememberMe: true,
    },
    admin: {
      autoPush: true,
      multiOptionalFactorEnroll: true,
      idpDiscovery: false,
      showPasswordToggleOnSignInPage: true,
      rememberMe: true,
    }
  }
};
